<template>
    <div class="autocomplete">
      <input type="text"
             v-model="query"
             @input="onInput"
             @focus="showSuggestions = true"
             @blur="hideSuggestions"
             :placeholder="placeholder"
             class="form-control"/>
  
      <ul v-show="showSuggestions" class="dropdown-menu-custom show">
        <li v-for="(item, index) in filteredSuggestions"
            :key="getKey(item, index)"
            @mousedown.prevent="selectSuggestion(item)"
            class="dropdown-item-custom">
            {{ getText(item) }}
        </li>
      </ul>
    </div>
  </template>
  
  <script>
  export default {
    name: 'AutoComplete',
    props: {
      suggestions: {
        type: Array,
        required: true
      },
      value: { // Prop for v-model
        type: [String, Object],
        required: false
      },
      placeholder:{
        type: String,
        required: false
      }
    },
    data() {
      return {
        query: '',
        showSuggestions: false
      };
    },
    computed: {
      filteredSuggestions() {
        /*return this.suggestions.filter(suggestion => 
          suggestion.toLowerCase().includes(this.query.toLowerCase())
        );*/
        return this.suggestions;
      }
    },
    methods: {
      onInput() {
        if (this.query.length > 0) {
          this.showSuggestions = true;
        } else {
          this.showSuggestions = false;
        }
        this.$emit('input-change', this.query);
      },
      selectSuggestion(suggestion) {
        this.query = this.getText(suggestion);
        this.showSuggestions = false;
        this.$emit('select', suggestion);
      },
      selectSuggestion(suggestion) {
        this.query = this.getText(suggestion);

        // Emit input event for v-model binding
        this.$emit('input', suggestion);

        this.showSuggestions = false;
        this.$emit('select', suggestion);
      },
      hideSuggestions() {
        // Small delay to ensure click completes before hiding
        setTimeout(() => {
          this.showSuggestions = false;
        }, 100);
      },
      getKey(item, index) {
        return typeof item === 'object' && 'value' in item ? item.value : index;
      },
      getText(item) {
        return typeof item === 'object' && 'label' in item ? item.label : item;
      }
    }
  };
  </script>
  
  <style scoped>
  .autocomplete {
    position: relative;
    display: inline-block;
    width: 100%;
  }
  
  .autocomplete input {
    width: 100%;
  }
  
  .dropdown-menu-custom {
    background: white;
    list-style: none;
    padding: 0;
    margin: 0;
    position: absolute;
    width: 100%;
    max-height: 200px;
    overflow-y: auto;
    z-index: 1000;
    border: 1pt solid gray;
  }
  
  .dropdown-item-custom {
    padding: .5rem 1rem;
    cursor: pointer;
  }
  
  .dropdown-item-custom:hover {
    background-color: #f8f9fa;
  }
  </style>